module.exports = __webpack_public_path__ + "static/Montaz_wspornikow_Decra-b3895cb3f131053550b8a7f8d3246f76.pdf";